"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeConfig = void 0;
class CTGGameModeConfig {
    constructor(title, description, game_mode) {
        this.title = title;
        this.description = description;
        this.game_mode = game_mode;
    }
}
exports.CTGGameModeConfig = CTGGameModeConfig;
